import { useSelector } from 'react-redux';
import { PackageType } from '../enums/essential-ui/PackageType';
import { AppState } from '../store/AppState';
import { UserDealerState } from '../store/userDealer/UserDealerSlice';
import { UserDealerModel } from '../types/essential-ui/UserDealerModel';

export const useUserDealer = (): useUserReturnType => {
  const { userDealer, isUserDealerDataLoading } = useSelector<AppState, UserDealerState>(
    (state) => state.userDealer,
  );

  if (userDealer == null) {
    const userDealerLocaleStorage = localStorage.getItem('userDealerModel');
    if (userDealerLocaleStorage !== null) {
      const userDealerModel: UserDealerModel = JSON.parse(userDealerLocaleStorage);
      return {
        storeCode: userDealerModel.storeCode,
        identityUserId: userDealerModel.identityUserId,
        isError: false,
        isLoadingUserDealer: false,
        packageType: userDealerModel.packageType,
        isIncentiveAdvantageType:
          userDealerModel.packageType == PackageType.DealerActivator ||
          userDealerModel.packageType == PackageType.DealerActivatorLite,
        isEssentialType:
          userDealerModel.packageType == PackageType.DealerActivator ||
          userDealerModel.packageType == PackageType.DealerActivatorLite ||
          userDealerModel.packageType == PackageType.Blueberry ||
          userDealerModel.packageType == PackageType.BlueberryPlus,
      };
    } else {
      return {
        storeCode: '',
        identityUserId: '',
        isError: true,
        isLoadingUserDealer: false,
        packageType: 0,
        isIncentiveAdvantageType: false,
        isEssentialType: false,
      };
    }
  }
  return {
    storeCode: userDealer!.storeCode || null,
    identityUserId: userDealer!.identityUserId,
    isLoadingUserDealer: isUserDealerDataLoading,
    packageType: userDealer.packageType,
    isIncentiveAdvantageType:
      userDealer.packageType == PackageType.DealerActivator ||
      userDealer.packageType == PackageType.DealerActivatorLite,
    isEssentialType:
      userDealer.packageType == PackageType.DealerActivator ||
      userDealer.packageType == PackageType.DealerActivatorLite ||
      userDealer.packageType == PackageType.Blueberry ||
      userDealer.packageType == PackageType.BlueberryPlus,
  };
};

export type useUserReturnType = {
  storeCode: string | null;
  identityUserId?: string;
  isLoadingUserDealer: boolean;
  isError?: boolean;
  packageType?: number;
  isIncentiveAdvantageType: boolean;
  isEssentialType: boolean;
};
